import { reactive } from 'vue'

// Global reactive toast state
export const toastState = reactive({
  show: false,
  message: '',
  color: 'error',
  timeout: 3000,
  location: 'top',
})

const setToast = (color, message, timeout = 3000, location = 'top') => {
  toastState.message = message
  toastState.color = color
  toastState.timeout = timeout
  toastState.location = location
  toastState.show = true
}

export const toast = {
  error: (m, t, l) => setToast('error', m, t, l),
  warning: (m, t, l) => setToast('warning', m, t, l),
  success: (m, t, l) => setToast('success', m, t, l),
  info: (m, t, l) => setToast('info', m, t, l),
}

